// app/javascript/controllers/chart_controller.js

import { Controller } from "stimulus";
import $ from "jquery";
import "select2";

export default class extends Controller {
  static targets = ["chartVisualizerPartial"];
  connect() {
    this.loadGoogleCharts();
    this.initializeSelect2();
    this.initializeSelect2Missions();
    console.log(this.urlSolution);
    console.log(this.urlSolution);
  }
  userLang = this.getUserLang();
  getFirstPathSegment() {
    const pathname = window.location.pathname;
    const pathSegments = pathname
      .split("/")
      .filter((segment) => segment.length > 0);
    return pathSegments.length > 0 ? `/${pathSegments[0]}` : "";
  }

  initializeSelect2() {
    const selectElement = document.querySelector("#with_entreprise_id");
    if (selectElement) {
      const inputTooShort = $(selectElement).data("input-too-short");
      const noResults = $(selectElement).data("no-results");
      const searching = $(selectElement).data("searching");
      const removeAllItems = $(selectElement).data("remove-all-items");
      const placeholderSearchClient = $(selectElement).data(
        "placeholder-search-client",
      );

      console.log("Initializing Select2:", window.location);
      const currentApp = this.getFirstPathSegment();

      $(selectElement).select2({
        ajax: {
          url: `${window.location.origin}${currentApp}/entreprises/search_entreprise_client?vr2=1`,
          dataType: "json",
          delay: 250,
          data: function (params) {
            return {
              term: params.term,
            };
          },
          processResults: function (data) {
            return {
              results: data.map(function (item) {
                return {
                  id: item[1],
                  text: item[0],
                };
              }),
            };
          },
          cache: true,
        },
        minimumInputLength: 3,
        placeholder: placeholderSearchClient,
        language: {
          inputTooShort: () => inputTooShort,
          noResults: () => noResults,
          searching: () => searching,
          removeAllItems: () => removeAllItems,
        },
        allowClear: true,
      });

      // Détacher tout événement select2:select préexistant
      $(selectElement).off("select2:select");
      // Détacher tout événement select2:unselect préexistant
      $(selectElement).off("select2:unselect");
      // Attacher l'événement select2:select
      $(selectElement).on("select2:select", (event) => {
        console.log("by select2:select");

        const selectedId = event.params.data.id;
        $(selectElement).data("selected-id", selectedId);

        const chartStrDataUrl = $("#str_data_url_hidden").value;
        const chartFilterName = $(selectElement).data("chart-filter-name");

        console.log("Select2 select event triggered:", {
          chartStrDataUrl,
          selectedId,
          chartFilterName,
          event,
        });

        // Appeler la méthode updateStrDataUrl avec le bon contexte
        this.updateStrDataUrl(
          event,
          chartStrDataUrl,
          selectedId,
          chartFilterName,
        );
      });

      // Attacher l'événement select2:unselect
      $(selectElement).on("select2:unselect", (event) => {
        // Mettre selectedId à -1 pour la déselection
        console.log("by select2:unselect");
        const selectedId = -1;
        $(selectElement).removeData("selected-id");

        const chartStrDataUrl = $("#str_data_url_hidden").value;
        const chartFilterName = $(selectElement).data("chart-filter-name");

        console.log("Select2 unselect event triggered:", {
          chartStrDataUrl,
          selectedId,
          chartFilterName,
          event,
        });

        // Appeler la méthode updateStrDataUrl avec le bon contexte pour la déselection
        this.updateStrDataUrl(
          event,
          chartStrDataUrl,
          selectedId,
          chartFilterName,
        );
      });
    }
  }

  initializeSelect2Missions() {
    const selectElement = document.querySelector("#with_mission_id");
    if (selectElement) {
      const inputTooShort = $(selectElement).data("input-too-short");
      const noResults = $(selectElement).data("no-results");
      const searching = $(selectElement).data("searching");
      const removeAllItems = $(selectElement).data("remove-all-items");
      const placeholderSearchClient = $(selectElement).data(
        "placeholder-search-client",
      );

      console.log("Initializing Select2:", window.location);
      const currentApp = this.getFirstPathSegment();

      $(selectElement).select2({
        ajax: {
          url: `${window.location.origin}${currentApp}/missions/search_mission?vr2=1`,
          dataType: "json",
          delay: 250,
          data: function (params) {
            return {
              term: params.term,
            };
          },
          processResults: function (data) {
            return {
              results: data.map(function (item) {
                return {
                  id: item[1],
                  text: item[0],
                };
              }),
            };
          },
          cache: true,
        },
        minimumInputLength: 3,
        placeholder: placeholderSearchClient,
        language: {
          inputTooShort: () => inputTooShort,
          noResults: () => noResults,
          searching: () => searching,
          removeAllItems: () => removeAllItems,
        },
        allowClear: true,
      });

      // Détacher tout événement select2:select préexistant
      $(selectElement).off("select2:select");
      // Détacher tout événement select2:unselect préexistant
      $(selectElement).off("select2:unselect");
      // Attacher l'événement select2:select
      $(selectElement).on("select2:select", (event) => {
        console.log("by select2:select");

        const selectedId = event.params.data.id;
        $(selectElement).data("selected-id", selectedId);

        const chartStrDataUrl = $("#str_data_url_hidden").value;
        const chartFilterName = $(selectElement).data("chart-filter-name");

        console.log("Select2 select event triggered:", {
          chartStrDataUrl,
          selectedId,
          chartFilterName,
          event,
        });

        // Appeler la méthode updateStrDataUrl avec le bon contexte
        this.updateStrDataUrl(
          event,
          chartStrDataUrl,
          selectedId,
          chartFilterName,
        );
      });

      // Attacher l'événement select2:unselect
      $(selectElement).on("select2:unselect", (event) => {
        // Mettre selectedId à -1 pour la déselection
        console.log("by select2:unselect");
        const selectedId = -1;
        $(selectElement).removeData("selected-id");

        const chartStrDataUrl = $("#str_data_url_hidden").value;
        const chartFilterName = $(selectElement).data("chart-filter-name");

        console.log("Select2 unselect event triggered:", {
          chartStrDataUrl,
          selectedId,
          chartFilterName,
          event,
        });

        // Appeler la méthode updateStrDataUrl avec le bon contexte pour la déselection
        this.updateStrDataUrl(
          event,
          chartStrDataUrl,
          selectedId,
          chartFilterName,
        );
      });
    }
  }

  displayStaticMessages() {
    console.log("Input too short message:", this.inputTooShortValue);
    console.log("No results message:", this.noResultsValue);
    console.log("Searching message:", this.searchingValue);
    console.log("Remove all items message:", this.removeAllItemsValue);
  }

  loadGoogleCharts() {
    // Ajout de html2canvas
    const scriptHtml2Canvas = document.createElement("script");
    scriptHtml2Canvas.src =
      "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.3.2/html2canvas.min.js";
    scriptHtml2Canvas.async = true;
    scriptHtml2Canvas.onload = () => {
      // html2canvas has been loaded, now you can use it
      console.log("html2canvas is loaded and ready to use.");
    };
    document.head.appendChild(scriptHtml2Canvas);
    const script = document.createElement("script");
    script.src = "https://www.gstatic.com/charts/loader.js";
    script.async = true;
    script.onload = () => {
      // Google Charts Loader has been loaded, now you can use it
      google.charts.load("current", {
        language: this.userLang,
        packages: ["corechart", "table"],
      });

      const chartType = this.getParameterByName("chart_type");
      const chartTypeButton = document.querySelector("#" + chartType);
      if (chartTypeButton) {
        chartTypeButton.click();
      } else {
        console.error(
          "Le bouton avec la classe correspondant à '" +
            chartType +
            "' n'a pas été trouvé.",
        );
      }
    };
    document.head.appendChild(script);
  }

  exportToCSV(data) {
    let csvContent = "data:text/csv;charset=utf-8,";
    data.forEach(function (rowArray) {
      let row = rowArray.join(",");
      csvContent += row + "\r\n";
    });

    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  }

  showGoogleTable() {
    jQuery(".bouton-submit").hide();
    jQuery(".child-loader").show();

    const strDataUrl = this.strDataUrl;
    const httpGet = (theUrl) => {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", theUrl, false);
      xmlHttp.send(null);
      return xmlHttp.responseText;
    };
    google.charts.setOnLoadCallback(() => {
      console.log(this.strDataUrl);

      const topass = JSON.parse(
        httpGet(strDataUrl ?? "katalyse_test/missions/chart_data_14172"),
      );

      // Construisez le tableau de données pour Google Charts
      const data = new google.visualization.DataTable();

      let alink = -1; // Déclarer alink ici

      for (let i = 0; i < topass[0].length; i++) {
        if (i === 1) {
          data.addColumn("number", topass[0][i]);
        } else {
          data.addColumn("string", topass[0][i]);
          if (topass[0][i] === "lien_graphe") {
            alink = i;
          }
        }
      }

      if (Array.isArray(topass)) {
        topass.splice(0, 2);
      } else {
        console.error("Expected topass to be an array, but it is not:", topass);
      }
      this.displayNoDataMessage(topass);
      if (topass.length == 0) {
        // If there's not enough data, no need to proceed further
        return;
      }
      for (let i = 1; i <= topass.length; i++) {
        const rowData = [];
        for (let j = 0; j < topass[i - 1].length; j++) {
          // Utilisez topass[i - 1] pour accéder aux données de la ligne i
          if (j === alink) {
            // Si c'est la colonne 'lien_Graph', ajoutez un lien avec une icône
            const link = topass[i - 1][alink]; // Utilisez topass[i - 1] pour accéder aux données de la ligne i
            const iconLink = `<a href="${link}" target="_blank"><i class="fa fa-external-link-alt"></i></a>`;
            rowData.push(iconLink);
          } else {
            rowData.push(topass[i - 1][j]); // Utilisez topass[i - 1] pour accéder aux données de la ligne i
          }
        }
        data.addRow(rowData);
      }

      // Configuration de la table
      const tableOptions = {
        title: "",
        chartArea: { left: 10, top: 35, width: "100%", height: "90%" },
        legend: { position: "right", textStyle: { fontSize: 11 } },
        is3D: false,
        allowHtml: true,
      };

      // Créez la table
      const table = new google.visualization.Table(
        document.getElementById("chart_div"),
      );
      table.draw(data, tableOptions);
      jQuery(".child-loader").hide();

      // Ajout du bouton d'exportation d'image au conteneur spécifié sur votre page

      const exportButton = document.createElement("button");
      const iconElement = document.createElement("i");
      iconElement.className = "ps-1 fa-solid fa-file-csv";
      exportButton.appendChild(iconElement);
      exportButton.className = "export-button  fx-button";

      exportButton.addEventListener("click", () => {
        // Supposons que 'data' est votre google.visualization.DataTable
        var csv = [];
        var rows = data.getNumberOfRows(); // Utilisez directement 'data' ici
        var cols = data.getNumberOfColumns();

        // Ajout des en-têtes
        var row = [];
        for (var col = 0; col < cols - 1; col++) {
          // Modifier la condition pour exclure la dernière colonne
          // Échappez les en-têtes si nécessaire
          row.push('"' + data.getColumnLabel(col).replace(/"/g, '""') + '"');
        }
        csv.push(row.join(","));

        // Ajout des données
        for (var i = 0; i < rows; i++) {
          row = [];
          for (var j = 0; j < cols - 1; j++) {
            // Modifier la condition pour exclure la dernière colonne
            var dataString = data.getFormattedValue(i, j);
            dataString = '"' + dataString.replace(/"/g, '""') + '"';
            row.push(dataString);
          }
          csv.push(row.join(","));
        }

        var csvString = csv.join("\n");
        var blob = new Blob(["\ufeff", csvString], {
          type: "text/csv;charset=utf-8;",
        });
        var url = URL.createObjectURL(blob);

        // Remplacez 'this.createFileName('csv')' par votre logique pour générer le nom du fichier
        const fileName = this.createFileName("csv");

        const downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });

      // Création du bouton d'exportation d'image pour la table
      const exportImgTableButton = document.createElement("button");
      const iconImgTableElement = document.createElement("i");
      iconImgTableElement.className = "ps-1 fa-solid fa-file-image";
      exportImgTableButton.appendChild(iconImgTableElement);
      exportImgTableButton.className = "export-button ms-2 fx-button";
      const self = this; // Capture 'this' au niveau où 'this' est l'objet contenant 'createFileName'

      // Ajout de l'écouteur d'événement sur exportImgTableButton
      exportImgTableButton.addEventListener("click", () => {
        html2canvas(document.getElementById("chart_div")).then(
          function (canvas) {
            const imgUri = canvas.toDataURL("image/png"); // Conversion du canvas en URI d'image
            const downloadLink = document.createElement("a");
            const fileName = self.createFileName("png"); // Utilisation de la fonction createCSVFileName
            downloadLink.href = imgUri;
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          },
        );
      });

      document.getElementById("export_button_container").innerHTML = "";
      document
        .getElementById("export_button_container")
        .appendChild(exportButton);
      document
        .getElementById("export_button_container")
        .appendChild(exportImgTableButton);

      this.updateUrlChartTypeParameter("table_chart");
      this.scrollToLink();
      // Cibler l'élément table avec la classe 'google-visualization-table-table'
      let tableElement = document.querySelector(
        "table.google-visualization-table-table",
      );

      // Vérifier si l'élément existe avant d'ajouter une classe
      if (tableElement) {
        tableElement.classList.add("fx-table-hm");
      } else {
        console.log(
          "Aucune table avec la classe 'google-visualization-table-table' n'a été trouvée.",
        );
      }
    });
  }

  createFileName(filetype) {
    const titleElement = document.querySelector(".title-text");
    const currentDate = new Date()
      .toLocaleDateString("fr-FR")
      .replace(/\//g, ""); // Obtient la date sous forme de chaîne sans les slashes
    const title = titleElement.innerHTML
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "_");
    return title + "_" + currentDate + "." + filetype;
  }
  httpGet(theUrl) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open("GET", theUrl, false);
    xmlHttp.send(null);
    return xmlHttp.responseText;
  }
  getUserLang() {
    const metaTag = document.querySelector('meta[name="current-user-lang"]');
    const lang = metaTag
      ? metaTag.content
      : document.documentElement.lang || "fr";
    return lang.toLowerCase().slice(0, 2);
  }

  showTable() {
    jQuery(".child-loader").show();

    // 1. Récupération des données (Format Google Array of Arrays)
    const rawData = JSON.parse(this.httpGet(this.strDataUrl));

    if (!rawData || rawData.length <= 2) {
      this.displayNoDataMessage([]);
      jQuery(".child-loader").hide();
      return;
    }

    // 2. Extraction des métadonnées
    const headersRaw = rawData[0];
    const dataRows = rawData.slice(2); // On saute les headers et la config graphe

    // Trouver l'index des colonnes spéciales
    const linkIdx = headersRaw.indexOf("lien_graphe");
    const annotIdx = headersRaw.indexOf("annotation");

    // Filtrer les headers pour l'affichage (on cache les colonnes techniques)
    const visibleHeaders = headersRaw.filter(
      (h) => h !== "lien_graphe" && h !== "annotation",
    );

    const lang =
      document.querySelector('meta[name="current-user-lang"]')?.content || "fr";
    const formatter = new Intl.NumberFormat(lang, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    let html = `<table class="fx-table-excel fix-col-first">
        <thead>
            <tr>
                ${visibleHeaders.map((h, i) => `<th class="${i === 0 ? "fx-sticky-col-first" : ""}">${h}</th>`).join("")}
            </tr>
        </thead>
        <tbody>
            ${dataRows
              .map((row) => {
                const link = linkIdx !== -1 ? row[linkIdx] : null;
                return `<tr>
                    ${row
                      .map((cell, i) => {
                        // On saute les colonnes techniques
                        if (i === linkIdx || i === annotIdx) return "";

                        let content = cell;
                        let isNumber = typeof cell === "number" && i > 0;

                        // Formatage si c'est un nombre
                        if (isNumber) {
                          content = formatter.format(cell);
                        }

                        // Gestion du lien avec alignement conditionnel
                        if (link) {
                          // Si ce n'est pas un nombre, on ajoute fx-text-left
                          const alignClass = !isNumber ? "fx-text-left" : "";
                          content = `<a href="${link}" target="_blank" class="fx-cell-link ${alignClass}">${content}</a>`;
                        }

                        return `<td class="${i === 0 ? "fx-sticky-col-first fx-col-label" : "fx-cell-val"}">${content}</td>`;
                      })
                      .join("")}
                </tr>`;
              })
              .join("")}
        </tbody>
    </table>`;

    document.getElementById("chart_div").innerHTML = html;
    jQuery(".child-loader").hide();
    this.updateUrlChartTypeParameter("table_chart");
  }

  showCrossTable() {
    jQuery(".child-loader").show();
    const response = JSON.parse(this.httpGet(this.strDataUrl));
    const headerCount = response.headers.length;
    const lang =
      document.querySelector('meta[name="current-user-lang"]')?.content || "fr";

    // Formateur par défaut (Fallback)
    const defaultFormatter = new Intl.NumberFormat(lang, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    // Fonction interne pour formater avec options dynamiques
    const smartFormat = (val, options = {}) => {
      if (val === undefined || val === null || isNaN(val)) return "";

      // Si pas d'options, on utilise le formateur par défaut pour ne pas casser l'existant
      if (options.digits === undefined && !options.unit) {
        return defaultFormatter.format(val);
      }

      const d = options.digits !== undefined ? options.digits : 2;
      const fmt = new Intl.NumberFormat(lang, {
        minimumFractionDigits: d,
        maximumFractionDigits: d,
      }).format(val);

      return options.unit ? `${fmt} ${options.unit}` : fmt;
    };

    this.displayNoDataMessage(response.rows);
    if (response.rows.length === 0) return;

    let html = `<table class="fx-table-excel fix-col-first fix-col-last fix-row-last">
        <thead>
            <tr>
                ${response.headers
                  .map((h, i) => {
                    let cls =
                      i === 0
                        ? "fx-sticky-col-first"
                        : i === headerCount - 1
                          ? "fx-sticky-col-last"
                          : "";
                    return `<th class="${cls}">${h}</th>`;
                  })
                  .join("")}
            </tr>
        </thead>
        <tbody>
            ${response.rows
              .map(
                (row) => `
                <tr>
                    <td class="fx-sticky-col-first fx-col-label fx-text-left">
                        <a href="${row.link}" target="_blank">${row.label}</a>
                    </td>
                    ${row.cells
                      .map(
                        (cell) => `
                        <td class="fx-cell-val">
                            <a href="${cell.link}" target="_blank" class="fx-cell-link">
                                ${smartFormat(cell.value, cell)}
                            </a>
                        </td>
                    `,
                      )
                      .join("")}
                    <td class="fx-cell-val fx-sticky-col-last fx-row-total">
                        <a href="${row.total_link}" target="_blank">
                            ${smartFormat(row.total, row)}
                        </a>
                    </td>
                </tr>
            `,
              )
              .join("")}
        </tbody>
        <tfoot>
            <tr class="fx-total-row">
                ${response.footer
                  .map((f, i) => {
                    let cls = "fx-cell-val";
                    if (i === 0) cls += " fx-sticky-col-first";
                    else if (i === headerCount - 1)
                      cls += " fx-sticky-col-last";

                    let content = "";
                    if (typeof f === "object" && f.value !== undefined) {
                      content = smartFormat(f.value, f);
                    } else {
                      content = f.label || f;
                    }

                    if (f.link)
                      content = `<a href="${f.link}" target="_blank">${content}</a>`;
                    return `<td class="${cls}">${content}</td>`;
                  })
                  .join("")}
            </tr>
        </tfoot>
    </table>`;

    document.getElementById("chart_div").innerHTML = html;
    jQuery(".child-loader").hide();
    this.updateUrlChartTypeParameter("cross_table");
  }
  formatCur(val) {
    if (val === null || val === undefined || isNaN(val)) return "0,00";

    //Récupérer la langue depuis le meta (défaut 'fr' si absent)
    const userLangMeta = document.querySelector(
      'meta[name="current-user-lang"]',
    );
    const userLang = userLangMeta ? userLangMeta.getAttribute("content") : "fr";

    //Formater dynamiquement

    return new Intl.NumberFormat(userLang, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true,
    }).format(val);
  }

  showPieChart() {
    jQuery(".child-loader").show();

    const strDataUrl = this.strDataUrl;
    const httpGet = (theUrl) => {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", theUrl, false);
      xmlHttp.send(null);
      return xmlHttp.responseText;
    };

    google.charts.setOnLoadCallback(() => {
      const topass = JSON.parse(
        httpGet(this.strDataUrl ?? "katalyse_test/missions/chart_data_14172"),
      );
      const legendtype = [];
      let alink = -1;

      for (let i = 0; i < topass[0].length; i++) {
        if (topass[0][i] == "annotation")
          legendtype.push({ role: "annotation" });
        else if (topass[0][i] == "lien_graphe") {
          legendtype.push({ role: "link" });
          alink = i;
        } else legendtype.push(topass[0][i]);
      }
      if (Array.isArray(topass)) {
        topass.splice(0, 2);
      } else {
        console.error("Expected topass to be an array, but it is not:", topass);
      }

      this.displayNoDataMessage(topass);
      if (topass.length == 0) {
        // If there's not enough data, no need to proceed further
        return;
      }
      const generatedColors = this.generateColorPalette(topass.length);
      const data = [legendtype].concat(topass);
      const options = {
        title: "",
        chartArea: { left: 10, top: 35, width: "100%", height: "90%" },
        legend: { position: "right", textStyle: { fontSize: 11 } },
        is3D: false, // Activez la visualisation en 3D
        colors: generatedColors,
      };

      const chart = new google.visualization.PieChart(
        document.getElementById("chart_div"),
      );

      if (alink !== -1) {
        google.visualization.events.addListener(chart, "select", (e) => {
          const selection = chart.getSelection();
          if (selection.length) {
            const row = selection[0].row;
            const link = data[row + 1][alink]; // Accès direct à la colonne 'alink' dans la ligne sélectionnée
            window.open(link, "_blank");
          }
        });
      }

      const exportImgButton = document.createElement("button");
      const iconImgElement = document.createElement("i");
      iconImgElement.className = "ps-1 fa-solid fa-file-image";
      exportImgButton.appendChild(iconImgElement);
      exportImgButton.className = "export-button  ms-2  fx-button";

      exportImgButton.addEventListener("click", () => {
        const imgUri = chart.getImageURI();
        // Créer un élément de lien pour télécharger l'image
        const downloadLink = document.createElement("a");
        const fileName = this.createFileName("png"); // Utilisation de la fonction createCSVFileName
        downloadLink.href = imgUri;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });

      document.getElementById("export_button_container").innerHTML = "";
      document
        .getElementById("export_button_container")
        .appendChild(exportImgButton);

      const exportButton = document.createElement("button");
      const iconElement = document.createElement("i");
      iconElement.className = "ps-1 fa-solid fa-file-csv";
      exportButton.appendChild(iconElement);
      exportButton.className = "export-button  fx-button";

      exportButton.addEventListener("click", () => {
        const csvData = this.convertToCSV(topass);
        const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const fileName = this.createFileName("csv"); // Utilisation de la fonction createCSVFileName

        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          alert(
            "Votre navigateur ne prend pas en charge cette fonctionnalité.",
          );
        }
      });

      document.getElementById("export_button_container").innerHTML = "";
      document
        .getElementById("export_button_container")
        .appendChild(exportButton);
      document
        .getElementById("export_button_container")
        .appendChild(exportImgButton);

      chart.draw(google.visualization.arrayToDataTable(data), options);
      jQuery(".child-loader").hide();
    });

    this.updateUrlChartTypeParameter("pie_chart");
    this.scrollToLink();
  }
  convertToCSV(data) {
    const csvRows = [];

    // Boucle à travers les données et formatage en CSV
    data.forEach((row) => {
      // Retire le dernier élément de chaque ligne avant de la convertir en CSV
      const rowWithoutLastColumn = row.slice(0, -1); // Utilise slice pour enlever le dernier élément
      const csvRow = rowWithoutLastColumn
        .map((value) => {
          // Assurez-vous que chaque valeur est correctement échappée
          return '"' + value.toString().replace(/"/g, '""') + '"';
        })
        .join(",");
      csvRows.push(csvRow);
    });

    // Joindre les lignes CSV avec un saut de ligne
    return csvRows.join("\n");
  }

  showLineChart() {
    jQuery(".bouton-submit").hide();
    jQuery(".child-loader").show();

    const strDataUrl = this.strDataUrl;

    const httpGet = (theUrl) => {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", theUrl, false);
      xmlHttp.send(null);
      return xmlHttp.responseText;
    };

    const getMax = (array) => {
      var max = 0;
      for (var i = 2; i < array.length; i++) {
        if (parseInt(array[i][1]) > max) max = parseInt(array[i][1]);
      }
      return max;
    };

    const getMin = (array) => {
      var min = 0;
      for (var i = 2; i < array.length; i++) {
        if (parseInt(array[i][1]) < min) min = parseInt(array[i][1]);
      }
      return min;
    };

    const exportButton = document.createElement("button");
    const iconElement = document.createElement("i");
    iconElement.className = "ps-1 fa-solid fa-file-csv";
    exportButton.appendChild(iconElement);
    exportButton.className = "export-button  fx-button";

    exportButton.addEventListener("click", () => {
      const topass = JSON.parse(httpGet(this.strDataUrl));
      const csvData = this.convertToCSV(topass);
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const fileName = this.createFileName("csv");

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        alert("Votre navigateur ne prend pas en charge cette fonctionnalité.");
      }
    });

    google.charts.setOnLoadCallback(() => {
      const topass = JSON.parse(httpGet(this.strDataUrl));
      const max = getMax(topass);
      const min = getMin(topass);
      const legendtype = [];
      let alink = -1;

      for (let i = 0; i < topass[0].length; i++) {
        if (topass[0][i] === "annotation")
          legendtype.push({ role: "annotation" });
        else if (topass[0][i] === "lien_graphe") {
          legendtype.push({ role: "link" });
          alink = i;
        } else legendtype.push(topass[0][i]);
      }

      if (Array.isArray(topass)) {
        topass.splice(0, 2);
      } else {
        console.error("Expected topass to be an array, but it is not:", topass);
      }

      this.displayNoDataMessage(topass);
      if (topass.length == 0) {
        return;
      }
      const data = [legendtype].concat(topass);

      const options = {
        legend: { position: "none" },
        seriesType: "line",
        pointSize: 2,
        colors: [
          "#125d52",
          "#df975e",
          "#ebac4f",
          "#78d738",
          "#27ad22",
          "#5ea699",
          "#1c27c3",
          "#6c3fe1",
          "#b91299",
          "#dc2bcd",
        ],
        hAxis: {
          slantedText: true,
          slantedTextAngle: 30,
          textStyle: {
            fontSize: 11,
            color: "#333",
          },
          showTextEvery: 1,
          maxAlternation: 1,
          maxTextLines: 1,
        },
        vAxis: {
          format: "short",
          viewWindowMode: "explicit",
          viewWindow: {
            max: max,
            min: min,
          },
        },
      };

      const chart = new google.visualization.ComboChart(
        document.getElementById("chart_div"),
      );

      const exportImgButton = document.createElement("button");
      const iconImgElement = document.createElement("i");
      iconImgElement.className = "ps-1 fa-solid fa-file-image";
      exportImgButton.appendChild(iconImgElement);
      exportImgButton.className = "export-button  ms-2 fx-button";

      exportImgButton.addEventListener("click", () => {
        const imgUri = chart.getImageURI();
        const downloadLink = document.createElement("a");
        downloadLink.href = imgUri;
        const fileName = this.createFileName("png");
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });

      document.getElementById("export_button_container").innerHTML = "";
      document
        .getElementById("export_button_container")
        .appendChild(exportButton);
      document
        .getElementById("export_button_container")
        .appendChild(exportImgButton);

      if (alink !== -1) {
        google.visualization.events.addListener(chart, "select", (e) => {
          const selection = chart.getSelection();
          if (selection.length) {
            const row = selection[0].row;
            const link = data[row + 1][alink];
            window.open(link, "_blank");
          }
        });
      }

      google.visualization.events.addListener(chart, "ready", () => {});

      chart.draw(google.visualization.arrayToDataTable(data), options);
      jQuery(".child-loader").hide();
    });

    this.updateUrlChartTypeParameter("line_chart");
    this.scrollToLink();
  }

  showContinuouseLineChart() {
    jQuery(".bouton-submit").hide();
    jQuery(".child-loader").show();

    const strDataUrl = this.strDataUrl;

    const httpGet = (theUrl) => {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", theUrl, false);
      xmlHttp.send(null);
      return xmlHttp.responseText;
    };

    const getMax = (array) => {
      var max = 0;
      for (var i = 2; i < array.length; i++) {
        if (parseInt(array[i][1]) > max) max = parseInt(array[i][1]);
      }
      return max;
    };

    const getMin = (array) => {
      var min = 0;
      for (var i = 2; i < array.length; i++) {
        if (parseInt(array[i][1]) < min) min = parseInt(array[i][1]);
      }
      return min;
    };

    const exportButton = document.createElement("button");
    const iconElement = document.createElement("i");
    iconElement.className = "ps-1 fa-solid fa-file-csv";
    exportButton.appendChild(iconElement);
    exportButton.className = "export-button fx-button";

    exportButton.addEventListener("click", () => {
      const topass = JSON.parse(httpGet(this.strDataUrl));
      const csvData = this.convertToCSV(topass);
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const fileName = this.createFileName("csv");

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        alert("Votre navigateur ne prend pas en charge cette fonctionnalité.");
      }
    });

    google.charts.setOnLoadCallback(() => {
      const topass = JSON.parse(httpGet(this.strDataUrl));
      const max = getMax(topass);
      const min = getMin(topass);
      const legendtype = [];
      let alink = -1;

      for (let i = 0; i < topass[0].length; i++) {
        if (topass[0][i] === "annotation")
          legendtype.push({ role: "annotation" });
        else if (topass[0][i] === "lien_graphe") {
          legendtype.push({ role: "link" });
          alink = i;
        } else legendtype.push(topass[0][i]);
      }

      if (Array.isArray(topass)) {
        topass.splice(0, 2);
      } else {
        console.error("Expected topass to be an array, but it is not:", topass);
      }

      this.displayNoDataMessage(topass);
      if (topass.length == 0) {
        return;
      }
      const data = [legendtype].concat(topass);

      const options = {
        legend: { position: "none" },
        seriesType: "line",
        pointSize: 2,
        colors: [
          "#125d52",
          "#df975e",
          "#ebac4f",
          "#78d738",
          "#27ad22",
          "#5ea699",
          "#1c27c3",
          "#6c3fe1",
          "#b91299",
          "#dc2bcd",
        ],
        hAxis: {
          slantedText: true,
          slantedTextAngle: 30,
          textStyle: {
            fontSize: 11,
            color: "#333",
          },
          showTextEvery: 1,
          maxAlternation: 1,
          maxTextLines: 1,
        },
        vAxis: {
          format: "short",
          viewWindowMode: "explicit",
          viewWindow: {
            max: max,
            min: min,
          },
        },
      };

      const chart = new google.visualization.ComboChart(
        document.getElementById("chart_div"),
      );

      const exportImgButton = document.createElement("button");
      const iconImgElement = document.createElement("i");
      iconImgElement.className = "ps-1 fa-solid fa-file-image";
      exportImgButton.appendChild(iconImgElement);
      exportImgButton.className = "export-button ms-2 fx-button";

      exportImgButton.addEventListener("click", () => {
        const imgUri = chart.getImageURI();
        const downloadLink = document.createElement("a");
        downloadLink.href = imgUri;
        const fileName = this.createFileName("png");
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });

      document.getElementById("export_button_container").innerHTML = "";
      document
        .getElementById("export_button_container")
        .appendChild(exportButton);
      document
        .getElementById("export_button_container")
        .appendChild(exportImgButton);

      if (alink !== -1) {
        google.visualization.events.addListener(chart, "select", (e) => {
          const selection = chart.getSelection();
          if (selection.length) {
            const row = selection[0].row;
            const link = data[row + 1][alink];
            window.open(link, "_blank");
          }
        });
      }

      google.visualization.events.addListener(chart, "ready", () => {});

      chart.draw(google.visualization.arrayToDataTable(data), options);
      jQuery(".child-loader").hide();
    });

    this.updateUrlChartTypeParameter("line_chart");
    this.scrollToLink();
  }
  drawCurveTypes() {
    const strDataUrl = this.strDataUrl;

    const httpGet = (theUrl) => {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", theUrl, false);
      xmlHttp.send(null);
      return xmlHttp.responseText;
    };

    const getMax = (array) => {
      var max = 0;
      for (var i = 2; i < array.length; i++) {
        if (parseInt(array[i][1]) > max) max = parseInt(array[i][1]);
      }
      return max;
    };

    const getMin = (array) => {
      var min = 0;
      for (var i = 2; i < array.length; i++) {
        if (parseInt(array[i][1]) < min) min = parseInt(array[i][1]);
      }
      return min;
    };

    const exportButton = document.createElement("button");
    const iconElement = document.createElement("i");
    iconElement.className = "ps-1 fa-solid fa-file-csv";
    exportButton.appendChild(iconElement);
    exportButton.className = "export-button fx-button";

    exportButton.addEventListener("click", () => {
      const topass = JSON.parse(httpGet(strDataUrl));
      const csvData = this.convertToCSV(topass);
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const fileName = this.createFileName("csv");

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        alert("Votre navigateur ne prend pas en charge cette fonctionnalité.");
      }
    });

    google.charts.setOnLoadCallback(() => {
      const jsonResponse = JSON.parse(httpGet(strDataUrl));
      const { dataTable, critere, titre, list_parametrage } = jsonResponse;

      var data = new google.visualization.DataTable();
      data.addColumn("string", critere);
      list_parametrage.forEach((p) => {
        data.addColumn("number", p.sil);
        if (dataTable.length == 1 && list_parametrage.length == 1) {
          data.addColumn({ type: "number", role: "annotation" });
        }
        data.addColumn({ type: "string", role: "tooltip", p: { html: true } });
      });

      const midpoint = Math.floor(dataTable.length / 2);
      data.addRows(dataTable.slice(0, midpoint + 1));
      data.addRows(dataTable.slice(midpoint + 1));

      var options = {
        title: titre,
        subtitle: "(Euro)",
        width: 1100,
        height: 500,
        focusTarget: "category",
        tooltip: { isHtml: true },

        hAxis: {
          title: "Date",
          slantedText: true,
          slantedTextAngle: 30,
          textStyle: {
            fontSize: 11,
            color: "#333",
          },
          showTextEvery: 1,
          maxAlternation: 1,
          maxTextLines: 1,
        },
        vAxis: {
          title: "Montant CA ",
          format: "short",
          gridlines: { count: 5 },
        },
      };

      var chart = new google.visualization.LineChart(
        document.getElementById("chart_div"),
      );
      chart.draw(data, options);
      jQuery("#loading_request").html("");

      const exportImgButton = document.createElement("button");
      const iconImgElement = document.createElement("i");
      iconImgElement.className = "ps-1 fa-solid fa-file-image";
      exportImgButton.appendChild(iconImgElement);
      exportImgButton.className = "export-button ms-2 fx-button";

      exportImgButton.addEventListener("click", () => {
        const imgUri = chart.getImageURI();
        const downloadLink = document.createElement("a");
        downloadLink.href = imgUri;
        const fileName = this.createFileName("png");
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });

      document.getElementById("export_button_container").innerHTML = "";
      document
        .getElementById("export_button_container")
        .appendChild(exportButton);
      document
        .getElementById("export_button_container")
        .appendChild(exportImgButton);

      jQuery(".child-loader").hide();
    });

    this.updateUrlChartTypeParameter("line_chart");
    this.scrollToLink();
  }

  showContinuouseLineChart_bis() {
    jQuery(".bouton-submit").hide();
    jQuery(".child-loader").show();

    const strDataUrl = this.strDataUrl;

    const httpGet = (theUrl) => {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", theUrl, false);
      xmlHttp.send(null);
      return xmlHttp.responseText;
    };

    const getMax = (array) => {
      var max = 0;
      for (var i = 2; i < array.length; i++) {
        if (parseInt(array[i][1]) > max) max = parseInt(array[i][1]);
      }
      return max;
    };

    const getMin = (array) => {
      var min = 0;
      for (var i = 2; i < array.length; i++) {
        if (parseInt(array[i][1]) < min) min = parseInt(array[i][1]);
      }
      return min;
    };

    const exportButton = document.createElement("button");
    const iconElement = document.createElement("i");
    iconElement.className = "ps-1 fa-solid fa-file-csv";
    exportButton.appendChild(iconElement);
    exportButton.className = "export-button  fx-button";

    exportButton.addEventListener("click", () => {
      const topass = JSON.parse(httpGet(this.strDataUrl));
      const csvData = this.convertToCSV(topass);
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const fileName = this.createFileName("csv");

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        alert("Votre navigateur ne prend pas en charge cette fonctionnalité.");
      }
    });

    google.charts.setOnLoadCallback(() => {
      const topass = JSON.parse(httpGet(this.strDataUrl));
      const max = getMax(topass);
      const min = getMin(topass);
      const legendtype = [];
      let alink = -1;

      for (let i = 0; i < topass[0].length; i++) {
        if (topass[0][i] === "annotation")
          legendtype.push({ role: "annotation" });
        else if (topass[0][i] === "lien_graphe") {
          legendtype.push({ role: "link" });
          alink = i;
        } else legendtype.push(topass[0][i]);
      }

      if (Array.isArray(topass)) {
        topass.splice(0, 2);
      } else {
        console.error("Expected topass to be an array, but it is not:", topass);
      }

      this.displayNoDataMessage(topass);
      if (topass.length == 0) {
        return;
      }
      const data = [legendtype].concat(topass);

      const options = {
        legend: { position: "none" },
        seriesType: "line",
        pointSize: 2,
        colors: [
          "#125d52",
          "#df975e",
          "#ebac4f",
          "#78d738",
          "#27ad22",
          "#5ea699",
          "#1c27c3",
          "#6c3fe1",
          "#b91299",
          "#dc2bcd",
        ],
        hAxis: {
          slantedText: true,
          slantedTextAngle: 30,
          textStyle: {
            fontSize: 11,
            color: "#333",
          },
          showTextEvery: 1,
          maxAlternation: 1,
          maxTextLines: 1,
        },
        vAxis: {
          format: "short",
          viewWindowMode: "explicit",
          viewWindow: {
            max: max,
            min: min,
          },
        },
      };

      const chart = new google.visualization.LineChart(
        document.getElementById("chart_div"),
      );

      const exportImgButton = document.createElement("button");
      const iconImgElement = document.createElement("i");
      iconImgElement.className = "ps-1 fa-solid fa-file-image";
      exportImgButton.appendChild(iconImgElement);
      exportImgButton.className = "export-button  ms-2 fx-button";

      exportImgButton.addEventListener("click", () => {
        const imgUri = chart.getImageURI();
        const downloadLink = document.createElement("a");
        downloadLink.href = imgUri;
        const fileName = this.createFileName("png");
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });

      document.getElementById("export_button_container").innerHTML = "";
      document
        .getElementById("export_button_container")
        .appendChild(exportButton);
      document
        .getElementById("export_button_container")
        .appendChild(exportImgButton);

      if (alink !== -1) {
        google.visualization.events.addListener(chart, "select", (e) => {
          const selection = chart.getSelection();
          if (selection.length) {
            const row = selection[0].row;
            const link = data[row + 1][alink];
            window.open(link, "_blank");
          }
        });
      }

      google.visualization.events.addListener(chart, "ready", () => {});

      chart.draw(google.visualization.arrayToDataTable(data), options);
      jQuery(".child-loader").hide();
    });

    this.updateUrlChartTypeParameter("line_chart");
    this.scrollToLink();
  }

  showColumn2DChart() {
    jQuery(".bouton-submit").hide();
    jQuery(".child-loader").show();

    const strDataUrl = this.strDataUrl;

    const httpGet = (theUrl) => {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", theUrl, false);
      xmlHttp.send(null);
      return xmlHttp.responseText;
    };

    const getMax = (array) => {
      var max = 0;
      for (var i = 2; i < array.length; i++) {
        if (parseInt(array[i][1]) > max) max = parseInt(array[i][1]);
      }
      return max;
    };

    const getMin = (array) => {
      var min = 0;
      for (var i = 2; i < array.length; i++) {
        if (parseInt(array[i][1]) < min) min = parseInt(array[i][1]);
      }
      return min;
    };

    const exportButton = document.createElement("button");
    const iconElement = document.createElement("i");
    iconElement.className = "ps-1 fa-solid fa-file-csv";
    exportButton.appendChild(iconElement);
    exportButton.className = "export-button  fx-button";

    exportButton.addEventListener("click", () => {
      const topass = JSON.parse(httpGet(this.strDataUrl));
      const csvData = this.convertToCSV(topass);
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const fileName = this.createFileName("csv"); // Utilisation de la fonction createCSVFileName

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        alert("Votre navigateur ne prend pas en charge cette fonctionnalité.");
      }
    });

    google.charts.setOnLoadCallback(() => {
      console.log(this.strDataUrl);

      const topass = JSON.parse(httpGet(this.strDataUrl));
      const max = getMax(topass);
      const min = getMin(topass);
      const legendtype = [];
      let alink = -1;

      for (let i = 0; i < topass[0].length; i++) {
        if (topass[0][i] === "annotation")
          legendtype.push({ role: "annotation" });
        else if (topass[0][i] === "lien_graphe") {
          legendtype.push({ role: "link" });
          alink = i;
        } else legendtype.push(topass[0][i]);
      }

      if (Array.isArray(topass)) {
        topass.splice(0, 2);
      } else {
        console.error("Expected topass to be an array, but it is not:", topass);
      }

      this.displayNoDataMessage(topass);
      if (topass.length == 0) {
        // If there's not enough data, no need to proceed further
        return;
      }
      const data = [legendtype].concat(topass);

      const options = {
        legend: { position: "none" },
        seriesType: "bars",
        series: { 3: { type: "bars" } },
        pointSize: 2,
        colors: [
          "#125d52",
          "#df975e",
          "#ebac4f",
          "#78d738",
          "#27ad22",
          "#5ea699",
          "#1c27c3",
          "#6c3fe1",
          "#b91299",
          "#dc2bcd",
        ],
        hAxis: {
          slantedText: true,
          slantedTextAngle: 30,
          textStyle: {
            fontSize: 11,
            color: "#333",
          },
          showTextEvery: 1,
          maxAlternation: 1,
          maxTextLines: 1,
        },
        vAxis: {
          format: "short",
          viewWindowMode: "explicit",
          viewWindow: {
            max: max,
            min: min,
          },
        },
      };

      const chart = new google.visualization.ComboChart(
        document.getElementById("chart_div"),
      );

      const exportImgButton = document.createElement("button");
      const iconImgElement = document.createElement("i");
      iconImgElement.className = "ps-1 fa-solid fa-file-image";
      exportImgButton.appendChild(iconImgElement);
      exportImgButton.className = "export-button  ms-2 fx-button";

      exportImgButton.addEventListener("click", () => {
        const imgUri = chart.getImageURI();
        // Créer un élément de lien pour télécharger l'image
        const downloadLink = document.createElement("a");
        downloadLink.href = imgUri;
        const fileName = this.createFileName("png");
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });

      document.getElementById("export_button_container").innerHTML = "";
      document
        .getElementById("export_button_container")
        .appendChild(exportButton);
      document
        .getElementById("export_button_container")
        .appendChild(exportImgButton);

      if (alink !== -1) {
        google.visualization.events.addListener(chart, "select", (e) => {
          const selection = chart.getSelection();
          if (selection.length) {
            const row = selection[0].row;
            const link = data[row + 1][alink]; // Accès direct à la colonne 'alink' dans la ligne sélectionnée
            window.open(link, "_blank");
          }
        });
      }

      google.visualization.events.addListener(chart, "ready", () => {});

      chart.draw(google.visualization.arrayToDataTable(data), options);
      jQuery(".child-loader").hide();
    });

    this.updateUrlChartTypeParameter("column_chart");
    this.scrollToLink();
  }

  updateUrlChartTypeParameter(chart_type) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("chart_type", chart_type); // Remplace la valeur du paramètre chart_type par chart_type
    const updatedParams = urlParams.toString();
    const newUrl = `${window.location.origin}${window.location.pathname}?${updatedParams}`;
    window.history.replaceState({ path: newUrl }, "", newUrl);
  }

  updateStrDataUrl(
    event,
    strDataUrl = null,
    filterData = null,
    filterName = null,
  ) {
    jQuery(".child-loader").show();

    // Utilisez les paramètres passés si disponibles, sinon utilisez les valeurs par défaut
    const effectiveStrDataUrl = strDataUrl || this.strDataUrl;
    const effectiveFilterData =
      filterData || (this.element ? this.element.value : null);

    // Si effectiveStrDataUrl et effectiveFilterData sont présents, mettez à jour strDataUrl
    if (effectiveStrDataUrl && effectiveFilterData) {
      const updatedStrDataUrl = this.replaceUrlParameters(
        effectiveStrDataUrl,
        effectiveFilterData,
        filterName,
      );

      const chartType = this.getParameterByName("chart_type");
      document
        .querySelector("#chart-visualizer-partial")
        .setAttribute("data-chart-str-data-url", updatedStrDataUrl);
      document
        .querySelector("#str_data_url_hidden")
        .setAttribute("value", updatedStrDataUrl);

      // IDs des éléments à mettre à jour
      var ids = [
        "created_at",
        "with_statut_mission_id",
        "with_statut_missions_valide_id",
        "parametrage_id",
        "with_mois",
        "with_annee",
        "with_statut",
        "with_exercice_id",
        "with_date_envoi",
        "with_entreprise_id",
        "with_mission_id",
        "with_offres_metier_id",
        "with_datedefacture",
        "with_date_reglement",
        "with_date_debut_inf",
        "with_date_fin_sup",
        "with_reglee",
        "str_data_url_hidden",
      ];

      // Parcours de tous les éléments du document
      ids.forEach(function (id) {
        // Recherche de l'élément avec l'ID spécifié
        var element = document.getElementById(id);
        // Vérification si l'élément est trouvé
        if (element !== null) {
          // Vérification de la présence de l'attribut "data-chart-str-data-url"
          if (element.hasAttribute("data-chart-str-data-url")) {
            // Mise à jour de la valeur de l'attribut avec le paramètre str_data_url
            element.setAttribute("data-chart-str-data-url", updatedStrDataUrl);
          }
        }
      });

      const chartTypeButton = document.querySelector("#" + chartType);
      if (chartTypeButton) {
        jQuery(".child-loader").show();
        chartTypeButton.click();
      } else {
        console.error(
          "Le bouton avec la classe correspondant à '" +
            chartType +
            "' n'a pas été trouvé.",
        );
      }
    }
  }

  displayNoDataMessage(dataArray) {
    // Check if the data array is empty or only contains headers
    if (!dataArray || dataArray.length == 0 || !Array.isArray(dataArray)) {
      // Assuming the first row is headers and there are no data rows
      const noDataContent = `
                  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%;">
                      <div style="text-align: center; padding: 20px; border: 1px solid #ccc; border-radius: 5px; background-color: #f9f9f9;">
                          <i class="fas fa-hdd" style="font-size: 48px; color: #ccc;"></i>
                          <p style="font-size: 14px;">Il n'y a pas de donnée à afficher.</p>
                      </div>
                  </div>
              `;
      jQuery("#chart_div").html(noDataContent); // Replace the content of the target element with the no data message
      jQuery(".child-loader").hide(); // Optionally hide the loader, if there's any
    }
  }
  calculateDateRange(date) {
    let start_date, end_date;
    const today = new Date();

    switch (parseInt(date)) {
      case 0:
        start_date = "all"; // Date de début arbitraire
        end_date = "all";
        break;
      case 1:
        start_date = new Date(today.getFullYear(), 0, 1);
        end_date = new Date(today.getFullYear(), 11, 31);
        break;
      case 2:
        start_date = new Date(today.getFullYear(), today.getMonth(), 1);
        end_date = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case 3:
        let day = today.getDay() || 7;
        start_date = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - day + 1,
        );
        end_date = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - day + 7,
        );
        break;
      case 4:
        start_date = new Date(today.getFullYear() - 1, 0, 1);
        end_date = new Date(today.getFullYear() - 1, 11, 31);
        break;
      case 5:
        let prevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        start_date = new Date(prevMonth.getFullYear(), prevMonth.getMonth(), 1);
        end_date = new Date(
          prevMonth.getFullYear(),
          prevMonth.getMonth() + 1,
          0,
        );
        break;
      case 6:
        let prevWeekStart = new Date(today);
        prevWeekStart.setDate(today.getDate() - 7 - today.getDay() + 1);
        let prevWeekEnd = new Date(prevWeekStart);
        prevWeekEnd.setDate(prevWeekStart.getDate() + 6);
        start_date = prevWeekStart;
        end_date = prevWeekEnd;
        break;
      default:
        start_date = "all"; // Date de début arbitraire
        end_date = "all";
        break;
    }
    return {
      start_date: end_date != "all" ? this.formatDate(start_date) : start_date,
      end_date: end_date != "all" ? this.formatDate(end_date) : end_date,
    };
  }

  // Fonction pour formater une date au format AAAA-MM-JJ
  formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  replaceUrlParameters(str_data_url, filterData, filterName) {
    return this.formatStrDataUrlAndUpdateParams(
      str_data_url,
      filterData,
      filterName,
    );
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  formatStrDataUrlAndUpdateParams(str_data_url, filterData, filterName) {
    console.log("str_data_url", str_data_url);

    // Créer un objet pour stocker les paramètres mis à jour
    var updatedParams = {};
    let decodedUrl = decodeURIComponent(str_data_url);
    let urlParts = decodedUrl.split("?");
    if (urlParts.length !== 2) {
      console.error("L'URL fournie est invalide.");
      return;
    }

    let baseUrl = urlParts[0];
    let queryString = urlParts[1];
    let params = queryString.split("&");
    params.forEach(function (param) {
      let keyValue = param.split("=");
      if (keyValue.length === 2) {
        let key = keyValue[0];
        let value = keyValue[1];
        updatedParams[key] = value;
      }
    });

    return this.updateParams(updatedParams, filterData, baseUrl, filterName);
  }

  updateParams(updatedParams, filterData, baseUrl, filterName) {
    const filterNameEffective =
      filterName != null ? filterName : this.filterName;

    if (filterNameEffective == "created_at") {
      // Vérifier si dateRange est défini et qu'il contient start_date et end_date
      const dateRange = this.calculateDateRange(filterData);
      if (dateRange && dateRange.start_date && dateRange.end_date) {
        // Mettre à jour les paramètres avec les nouvelles valeurs de date
        updatedParams["filterrific[with_date_creee_le_inf]"] =
          dateRange.start_date;
        updatedParams["filterrific[with_date_creee_le_sup]"] =
          dateRange.end_date;
      } else {
        console.error(
          "Les dates de la plage ne sont pas spécifiées correctement.",
        );
        updatedParams = updatedParams;
      }
    } else if (filterNameEffective == "with_date_reglement") {
      // Vérifier si dateRange est défini et qu'il contient start_date et end_date
      const dateRange = this.calculateDateRange(filterData);
      if (dateRange && dateRange.start_date && dateRange.end_date) {
        // Mettre à jour les paramètres avec les nouvelles valeurs de date
        updatedParams["filterrific[with_date_reglement_inf]"] =
          dateRange.start_date;
        updatedParams["filterrific[with_date_reglement_sup]"] =
          dateRange.end_date;
      } else {
        console.error(
          "Les dates de la plage ne sont pas spécifiées correctement.",
        );
        updatedParams = updatedParams;
      }
    } else if (filterNameEffective == "with_datedefacture") {
      // Vérifier si dateRange est défini et qu'il contient start_date et end_date
      const dateRange = this.calculateDateRange(filterData);
      if (dateRange && dateRange.start_date && dateRange.end_date) {
        // Mettre à jour les paramètres avec les nouvelles valeurs de date
        updatedParams["filterrific[with_datedefacture_inf]"] =
          dateRange.start_date;
        updatedParams["filterrific[with_datedefacture_sup]"] =
          dateRange.end_date;
      } else {
        console.error(
          "Les dates de la plage ne sont pas spécifiées correctement.",
        );
        updatedParams = updatedParams;
      }
    } else if (filterNameEffective == "with_date_envoi") {
      // Vérifier si dateRange est défini et qu'il contient start_date et end_date
      const dateRange = this.calculateDateRange(filterData);
      if (dateRange && dateRange.start_date && dateRange.end_date) {
        // Mettre à jour les paramètres avec les nouvelles valeurs de date
        updatedParams["filterrific[with_date_envoi_inf]"] =
          dateRange.start_date;
        updatedParams["filterrific[with_date_envoi_sup]"] = dateRange.end_date;
      } else {
        console.error(
          "Les dates de la plage ne sont pas spécifiées correctement.",
        );
        updatedParams = updatedParams;
      }
    } else if (filterNameEffective == "parametrage_id") {
      updatedParams["filterrific[with_entite]"] = filterData;
    } else if (filterNameEffective == "with_mois") {
      updatedParams["filterrific[with_mois]"] = filterData;
    } else if (filterNameEffective == "with_annee") {
      updatedParams["filterrific[with_annee]"] = filterData;
    } else if (filterNameEffective == "with_reglee") {
      updatedParams["filterrific[with_reglee]"] = filterData;
    } else if (filterNameEffective == "with_statut") {
      updatedParams["filterrific[with_statut]"] = filterData;
    } else if (filterNameEffective == "with_statut_mission_id") {
      updatedParams["filterrific[with_statut_mission_id]"] = filterData;
    } else if (filterNameEffective == "with_statut_missions_valide_id") {
      updatedParams["filterrific[with_statut_missions_valide_id]"] = filterData;
    } else if (filterNameEffective == "with_client_prospect") {
      updatedParams["filterrific[with_client_prospect]"] = filterData;
    } else if (filterNameEffective == "with_responsable_commercial") {
      updatedParams["filterrific[with_responsable_commercial]"] = filterData;
    } else if (filterNameEffective == "with_responsable_commercial_id") {
      updatedParams["filterrific[with_responsable_commercial_id]"] = filterData;
    } else if (filterNameEffective == "with_facture_envoyee") {
      updatedParams["filterrific[with_facture_envoyee]"] = filterData;
    } else if (filterNameEffective == "with_facture_emise") {
      updatedParams["filterrific[with_facture_emise]"] = filterData;
    } else if (filterNameEffective == "with_entreprise_id") {
      updatedParams["filterrific[with_entreprise_id]"] = filterData;
    } else if (filterNameEffective == "with_mission_id") {
      updatedParams["filterrific[with_mission_id]"] = filterData;
    } else if (filterNameEffective == "with_exercice_id") {
      updatedParams["filterrific[with_exercice_id]"] = filterData;
    } else if (filterNameEffective == "with_offres_metier_id") {
      updatedParams["filterrific[with_offres_metier_id]"] = filterData;
    } else if (filterNameEffective == "with_date_debut_inf") {
      updatedParams["filterrific[with_date_debut_inf]"] =
        this.formatToSqlDate(filterData);
    } else if (filterNameEffective == "with_date_fin_sup") {
      updatedParams["filterrific[with_date_fin_sup]"] =
        this.formatToSqlDate(filterData);
    } else {
      updatedParams = updatedParams;
    }

    // Reconstruire la chaîne de requête avec les paramètres mis à jour
    var newQueryString = Object.keys(updatedParams)
      .map(function (key) {
        return key + "=" + updatedParams[key];
      })
      .join("&");

    // Reconstruire l'URL complet
    var newUrl = baseUrl + "?" + newQueryString;
    return newUrl.replace(/&amp;/g, "&");
  }
  // Fonction utilitaire pour convertir le format JJ/MM/AAAA en AAAA-MM-JJ

  formatToSqlDate(dateStr) {
    if (!dateStr || !dateStr.includes("/")) return dateStr;

    var parts = dateStr.split("/");
    var year, month, day;

    if (this.userLang === "fr") {
      // Format attendu : JJ/MM/AAAA
      day = parts[0];
      month = parts[1];
      year = parts[2];
    } else {
      // Format attendu (en/Autre) : MM/JJ/AAAA
      month = parts[0];
      day = parts[1];
      year = parts[2];
    }

    // Retourne toujours le format ISO pour SQL : AAAA-MM-JJ
    return year + "-" + month + "-" + day;
  }
  scrollToLink() {
    var elementId = this.getParameterByName("a");
    var element = document.getElementById(elementId);

    if (element) {
      var parentElement = element.parentNode;

      // Vérifiez si le parent existe
      if (parentElement) {
        // Ajoutez une classe à l'élément parent
        parentElement.classList.add("chart-card-selected");
        console.log("La classe a été ajoutée avec succès à l'élément parent.");
      } else {
        console.log("Parent element not found.");
      }

      /* var container = document.querySelector('.chart-list');
        var containerRect = container.getBoundingClientRect();
        var elementRect = element.getBoundingClientRect();

        var relativeLeft = elementRect.left - containerRect.left;
        var scrollLeft = relativeLeft - (containerRect.width - elementRect.width) / 2;

        scrollLeft = Math.max(0, Math.min(scrollLeft, container.scrollWidth - containerRect.width));

        // Valeurs pour l'animation de défilement doux
        var duration = 1000; // Durée de l'animation en millisecondes
        var start = container.scrollLeft;
        var startTime = null;

        function animation(currentTime) {
            if (startTime === null) startTime = currentTime;
            var elapsedTime = currentTime - startTime;
            var scrollProgress = Math.min(elapsedTime / duration, 1);
            container.scrollLeft = start + (scrollLeft - start) * scrollProgress;

            if (scrollProgress < 1) {
                window.requestAnimationFrame(animation);
            }
        }

        window.requestAnimationFrame(animation);    */
    } else {
      console.error("L'élément avec l'ID spécifié n'a pas été trouvé.");
    }
  }

  generateColorPalette(n) {
    // console.time(`generateColorPalette(${n})`);
    const basePalette = [
      "#E57373",
      "#F4A261",
      "#F6C37F",
      "#FFF176",
      "#DCE775",
      "#AED581",
      "#81C784",
      "#4DD0E1",
      "#64B5F6",
      "#7986CB",
      "#BA68C8",
      "#F48FB1",
    ];

    function hslToHex(h, s, l) {
      s /= 100;
      l /= 100;
      const k = (n) => (n + h / 30) % 12;
      const a = s * Math.min(l, 1 - l);
      const f = (n) =>
        l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
      const toHex = (x) =>
        Math.round(x * 255)
          .toString(16)
          .padStart(2, "0");
      return `#${toHex(f(0))}${toHex(f(8))}${toHex(f(4))}`;
    }

    if (n <= basePalette.length) {
      // console.timeEnd(`generateColorPalette(${n})`);
      return basePalette.slice(0, n);
    }

    // Génère des couleurs supplémentaires
    const extraNeeded = n - basePalette.length;
    const extraColors = [];
    for (let i = 0; i < extraNeeded; i++) {
      const hue = (i * 360) / extraNeeded;
      extraColors.push(hslToHex(hue, 85, 60));
    }

    // console.timeEnd(`generateColorPalette(${n})`);
    return [...basePalette, ...extraColors].slice(0, n);
  }

  get strDataUrl() {
    return this.data.get("strDataUrl");
  }
  get filterName() {
    return this.data.get("filterName");
  }
  get filterId() {
    return this.data.get("filterId");
  }
}
